import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { HotelPolicyI18nZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type AccommodationHotelPolicyI18nFormModel = AutoGeneratorForFormModel<
	HotelPolicyI18nZodSchemaType,
	ExcludeKeys,
	QueryData
>;

export type QueryData = {
	hotel: {
		hotelEmailAddress: string;
	};
};
